import type { ProviderManifest } from '../../types';

export const cambaiManifest: ProviderManifest = {
  id: 'cambai',
  label: 'CambAI',
  shortLabel: 'Camb',
  vendor: 'Camb.ai',
  capabilities: { tts: true, stt: true },
  transport: { tts: 'ws-stream', stt: 'ws-stream' },
  // Voices are resolved dynamically from /list-voices at negotiate time, so we
  // cannot enumerate coverage statically. null = offer for every app language.
  languages: { tts: null, stt: null },
  exposesKeyToClient: true,
  notes:
    'Voice is picked dynamically from the vendor voice list; unmatched languages fall back to a default voice.',
};
